import React, { Component } from 'react'
import Item from '../../../item'
import Push from 'push.js';

export default class TrackList extends Component{
    componentWillMount(){
        window.p = Push;
    }

    render(){
        return(
            <div className="Tracker">
                {this.props.items.map(e=>
                    <Item type="min" {...e} key={e.id} tracker/>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/screens/HomeScreen/TrackListScreen/index.js